import React, { useMemo, useState, useEffect } from 'react';
import { connect } from 'react-redux';

import { makeGetTheme } from 'selectors/app-props';

import * as localStorage from 'services/local-storage-service';

import { DEFAULT_THEME } from 'constants/index';

export const ThemeContext = React.createContext();

const makeMapStateToProps = () => {
    const getTheme = makeGetTheme();

    return ({ appProps }) => ({
        theme: getTheme(appProps)
    });
}

export const ThemeProvider = connect(makeMapStateToProps)(({ theme, children }) => {
    const [themeOverride, setThemeOverride] = useState(null);
    const [lastTheme, setLastTheme] = useState(localStorage.get('nftTheme'));

    const currentTheme = useMemo(() => {
        return themeOverride || theme || lastTheme || DEFAULT_THEME;
    }, [themeOverride, theme]);

    const value = useMemo(() => ({
        theme: currentTheme,
        setThemeOverride,
        setLastTheme
    }), [currentTheme, setThemeOverride, setLastTheme]);

    useEffect(() => {
        Array.from(document.body.classList).forEach(className => {
            if (/nifty-theme-\w+/.test(className)) {
                document.body.classList.remove(className);
            }
        });

        document.body.classList.add(`nifty-theme-${currentTheme}`);

        localStorage.set('nftTheme', currentTheme);
    }, [currentTheme]);

    return (
        <ThemeContext.Provider value={value}>
            { children }
        </ThemeContext.Provider>
    )
});
